import React, { useState, useRef, useEffect, useContext } from "react";
import "./Navbar.css";

import Logo from "../../assets/images/logo.png";
import GermanFlag from "../../assets/images/germany.png";
import FranceFlag from "../../assets/images/france.png";
import Dropdown from "../Dropdown/Dropdown";
import { LanguageContext } from "../../context/LanguageContext";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { language, setLanguage } = useContext(LanguageContext);
  const [hovered, setHovered] = useState(false);

  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <div className="navbar_container">
      <div className="navbar_inner_container">
        <div className="logo_container">
          <a href="/">
            <img src={Logo} alt="logo" className="navbar_logo" />
          </a>
        </div>
        <div className="links_container">
          <ul className="navbar_links">
              <li style={{opacity: 0}}>
              <button
                className="navbar_link"
                onClick={() =>
                  window.scrollTo({
                    top: document.getElementsByClassName(
                      "statements_container"
                    )[0].offsetTop,
                    behavior: "smooth",
                  })
                }
              >
                {language === "german" ? "Statements" : "Déclarations"}
              </button>
              </li>
              <li>
              <button
                className="navbar_link"
                onClick={() =>
                  window.scrollTo({
                    top: document.getElementsByClassName(
                      "functions_container"
                    )[0].offsetTop,
                    behavior: "smooth",
                  })
                }
              >
                {language === "german" ? "Funktion" : "Les fonctions"}
              </button>
            </li>
            <li>
              <button
                className="navbar_link"
                onClick={() =>
                  window.scrollTo({
                    top: document.getElementsByClassName(
                      "partners_container"
                    )[0].offsetTop,
                    behavior: "smooth",
                  })
                }
              >
                {language === "german" ? "Partner" : "Partenaires"}
              </button>
            </li>
            {/*<li>
              <button
                className="navbar_link"
                onClick={() =>
                  window.scrollTo({
                    top: document.getElementsByClassName(
                      "statements_container"
                    )[0].offsetTop,
                    behavior: "smooth",
                  })
                }
              >
                {language === "german" ? "Statements" : "Déclarations"}
              </button>
              </li>*/}
            <li>
              <button
                className="navbar_link"
                onClick={() =>
                  window.scrollTo({
                    top: document.getElementsByClassName("contact_container")[0]
                      .offsetTop,
                    behavior: "smooth",
                  })
                }
              >
                {language === "german" ? "Kontakt" : "Contact"}
              </button>
            </li>
          </ul>
          <div
            className="language_flag_container"
            onClick={() => {
              const chosenLanugage =
                language === "german" ? "french" : "german";
              window.localStorage.setItem("language", chosenLanugage);
              setLanguage(chosenLanugage);
            }}
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <img
              src={
                hovered
                  ? language === "german"
                    ? FranceFlag
                    : GermanFlag
                  : language === "german"
                  ? GermanFlag
                  : FranceFlag
              }
              alt="lanugage_flag"
              className="language_flag"
            />
          </div>
        </div>

        <div
          className="hamburger_menu"
          onClick={() => {
            setOpen(!open);
          }}
          ref={ref}
        >
          <Dropdown open={open} />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
